import { MarbleButton } from "components/ui";
import * as React from "react";
import { IconBaseProps } from "react-icons/lib";
import {
  Card,
  CardBody,
  CardHeader,
  CardImg,
  CardTitle,
  Container,
} from "reactstrap";
import "./portal-panel.scss";
import { marbleTextLogoSvg } from "utils/StaticPaths";

export interface IActionButton {
  action: () => void;
  text: string;
  isDisabled?: boolean;
  icon?: IconBaseProps;
}

const PortalPanel: React.FC<{
  title?: string;
  image?: string;
  subtitle?: string;
  onGoBack?: () => void;
  onClose?: () => void;
  primaryButton?: IActionButton;
  secondaryButton?: IActionButton;
}> = ({
  title,
  image,
  subtitle,
  onGoBack,
  onClose,
  primaryButton,
  secondaryButton,
  children,
}) => {
  return (
    <Container className="d-flex justify-content-center align-items-center h-100">
      <Card className="portal-panel-card">
        <div className="d-flex mt-4 ms-3">
          {onGoBack && (
            <em
              style={{ cursor: "pointer" }}
              onClick={onGoBack}
              className="fas fa-arrow-left me-auto ms-2"
            />
          )}
          {onClose && (
            <em
              style={{ cursor: "pointer" }}
              onClick={onClose}
              className="fas fa-times"
            />
          )}
        </div>
        <div className="card-content">
          <CardHeader className="pt-0 px-0">
            {image && (
              <CardImg
                src={image}
                alt="logo"
                className="mt-3 mb-2"
                style={{ maxHeight: 160 }}
              />
            )}
            <div className="mb-3 mt-3 text-center">
              <CardImg
                src={marbleTextLogoSvg}
                className="portal-panel-marble-text-logo"
              />
            </div>
            <CardTitle>
              <h4 className="text-center portal-panel-title">{title}</h4>
              <h6 className="text-center portal-panel-subtitle">{subtitle}</h6>
            </CardTitle>
          </CardHeader>
          <CardBody className="p-0">
            <div>{children}</div>
          </CardBody>
          {(primaryButton || secondaryButton) && (
            <div className="d-flex flex-column ">
              {primaryButton && (
                <MarbleButton
                  type="primary"
                  className="w-100"
                  size="lg"
                  onClick={primaryButton.action}
                  isDisabled={primaryButton.isDisabled ?? false}
                >
                  {primaryButton.icon ?? primaryButton.icon}{" "}
                  {primaryButton.text}
                </MarbleButton>
              )}
              {secondaryButton && (
                <MarbleButton
                  type="secondary"
                  className="mt-3"
                  size="lg"
                  onClick={secondaryButton.action}
                  isDisabled={secondaryButton.isDisabled ?? false}
                >
                  {secondaryButton.text}
                </MarbleButton>
              )}
            </div>
          )}
        </div>
      </Card>
    </Container>
  );
};

export default PortalPanel;
